<template>
  <div class="user-preview">
    <UserAvatar
      :user="user"
    />
    <div class="user-name">
      {{ user?.name || $t('general.none') }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { UserForDisplay } from '@/api/openapi';

type TProps = {
  user: UserForDisplay | null;
};

defineProps<TProps>();
</script>

<style lang="scss" scoped>
.user-preview {
  @include m-flex-align-center;
  padding: $basespace-50;
  .user-name {
    @include m-flex-align-center;
    @include m-truncate-text;
    margin-left: $basespace-100;
  }
}
</style>
